import { render } from "./CIS-Profile-List.vue?vue&type=template&id=9a6bd5f6&scoped=true"
import script from "./CIS-Profile-List.vue?vue&type=script&lang=js"
export * from "./CIS-Profile-List.vue?vue&type=script&lang=js"

import "./CIS-Profile-List.vue?vue&type=style&index=0&id=9a6bd5f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6bd5f6"]])

export default __exports__